import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import {
  InspectedProductLocation,
  ProductInspectorService,
} from 'src/app/services/product-inspector.service';
import { ProductReference } from 'src/app/models/layout/product-reference';
import { ProductOrientation } from 'src/app/models/layout/product-orientation';
import { OverlayService, OverlayType } from 'src/app/services/overlay.service';
import { LabelType } from 'src/app/models/label-type';
import { LabelService } from 'src/app/services/label.service';
import { LayoutService } from 'src/app/services/layout.service';
import { ValidationError } from 'src/app/services/planogram-validation.service';
import { DialogService } from 'src/app/services/dialog.service';
import { SystemRole } from 'src/app/models/roles';
import { Subscription } from 'rxjs';
import { CapabilityType } from 'src/app/models/capability-type';
import { HasCapabilityDirective } from '../../../directives/has-capability.directive';
import { NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-planogram-toolbox',
    templateUrl: './planogram-toolbox.component.html',
    styleUrls: ['./planogram-toolbox.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        HasCapabilityDirective,
        NgbDropdown,
        NgbDropdownToggle,
        NgbDropdownMenu,
        NgbDropdownButtonItem,
        NgbDropdownItem,
    ],
})
export class PlanogramToolboxComponent implements OnInit, OnDestroy {
  SystemRole = SystemRole;
  selectedProduct: ProductReference | null = null;
  selectedOrientation: ProductOrientation = ProductOrientation.FRONT;
  inspectedProductLocation: InspectedProductLocation | null = null;
  orientationEnum = ProductOrientation;
  overlayType = OverlayType; // Expose the OverlayType enum
  labelType = LabelType; // Expose the OverlayType enum
  private subscriptions: Subscription = new Subscription();
  CapabilityType = CapabilityType;

  constructor(
    private productInspectorService: ProductInspectorService,
    private overlayService: OverlayService,
    private layoutService: LayoutService,
    private labelService: LabelService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.productInspectorService.inspectedProduct$.subscribe((productId) => {
        if (productId == null) {
          this.selectedProduct = null;
          return;
        }
        this.selectedProduct = this.productInspectorService.getProductReference();
      })
    );

    this.subscriptions.add(
      this.productInspectorService.inspectedProductLocation$.subscribe(
        (location) => {
          this.inspectedProductLocation = location;
        }
      )
    );
  }

  get hasInspectedProduct() {
    return this.selectedProduct && this.inspectedProductLocation != null;
  }

  ngOnDestroy(): void {
    // Clean up all subscriptions
    this.subscriptions.unsubscribe();
  }

  adjustFacings(type: 'h' | 'v', change: number) {
    if (!this.selectedProduct || !this.inspectedProductLocation) return;

    let dropIndex = this.inspectedProductLocation.dropIndex;
    let shelfIndex = this.inspectedProductLocation.shelfIndex;
    let stackIndex = this.inspectedProductLocation.stackIndex;
    let productIndex = this.inspectedProductLocation.productIndex;
    try {
      if (type == 'v') {
        if (change > 0) {
          this.layoutService.addVFacing(
            dropIndex,
            shelfIndex,
            stackIndex,
            productIndex
          );
        } else {
          this.layoutService.removeVFacing(
            dropIndex,
            shelfIndex,
            stackIndex,
            productIndex
          );
        }
      } else {
        if (change > 0) {
          this.layoutService.addHFacing(
            dropIndex,
            shelfIndex,
            stackIndex,
            productIndex
          );
        } else {
          this.layoutService.removeHFacing(
            dropIndex,
            shelfIndex,
            stackIndex,
            productIndex
          );
        }
      }
    } catch (error) {
      console.error(error);
      if (error instanceof ValidationError) {
        this.dialogService.showError(error.message);
      }
    }
  }

  updateOrientation(event: any) {
    if (!this.selectedProduct || !this.inspectedProductLocation) return;

    this.layoutService.changeProductOrientation(
      this.inspectedProductLocation.dropIndex,
      this.inspectedProductLocation.shelfIndex,
      this.inspectedProductLocation.stackIndex,
      this.inspectedProductLocation.productIndex,
      parseInt(event.target.value)
    );
  }

  clearOverlay() {
    this.overlayService.clearOverlay();
  }

  setOverlay(overlayType: OverlayType) {
    this.overlayService.setOverlayType(overlayType);
  }

  clearLabels() {
    this.labelService.hideLabels();
  }

  setLabels(labelType: LabelType) {
    if (this.labelService.currentLabelType() != labelType) {
      this.labelService.showLabels(labelType);
    }
  }

  isToolboxEnabled(): boolean {
    return this.inspectedProductLocation !== null;
  }
}
